import { render, staticRenderFns } from "./QuotationEdit.vue?vue&type=template&id=06ff152e&scoped=true"
import script from "./QuotationEdit.vue?vue&type=script&lang=js"
export * from "./QuotationEdit.vue?vue&type=script&lang=js"
import style0 from "./QuotationEdit.vue?vue&type=style&index=0&id=06ff152e&prod&scoped=true&lang=css"
import style1 from "./QuotationEdit.vue?vue&type=style&index=1&id=06ff152e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff152e",
  null
  
)

export default component.exports